import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CampusLocation } from '../models/campus-location.model';
import { RootState } from '../../../setup/store/store';

const campusLocationAdapter = createEntityAdapter<CampusLocation>();

export const campusLocationSlice = createSlice({
    initialState: campusLocationAdapter.getInitialState(),
    name: 'campusLocations',
    reducers: {
        campusLocationAddOne: campusLocationAdapter.addOne,
    },
});

export const campusLocationSelectors = campusLocationAdapter.getSelectors<RootState>(
    state => state.campusLocations,
);
